function injectStyle (ssrContext) {
  require("!!../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"autoprefixer\":false,\"sourceMap\":true,\"minimize\":true}!../../../node_modules/poi/node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-f6e5f540\",\"scoped\":false,\"hasInlineConfig\":true}!sass-loader?{\"sourceMap\":true}!../../../node_modules/poi/node_modules/vue-loader/lib/selector?type=styles&index=0!./CSpinner.vue")
}
var normalizeComponent = require("!../../../node_modules/poi/node_modules/vue-loader/lib/component-normalizer")
/* script */
export * from "!!babel-loader?{\"babelrc\":false,\"presets\":[[\"/home/runner/work/clube/clube/node_modules/babel-preset-poi/index.js\",{\"jsx\":\"vue\"}]],\"cacheDirectory\":true}!../../../node_modules/poi/node_modules/vue-loader/lib/selector?type=script&index=0!./CSpinner.vue"
import __vue_script__ from "!!babel-loader?{\"babelrc\":false,\"presets\":[[\"/home/runner/work/clube/clube/node_modules/babel-preset-poi/index.js\",{\"jsx\":\"vue\"}]],\"cacheDirectory\":true}!../../../node_modules/poi/node_modules/vue-loader/lib/selector?type=script&index=0!./CSpinner.vue"
/* template */
import __vue_template__ from "!!../../../node_modules/poi/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-f6e5f540\",\"hasScoped\":false,\"transformToRequire\":{\"img\":\"src\",\"image\":\"xlink:href\",\"cimage\":\"placeholder\",\"c-image\":\"placeholder\",\"CImage\":\"placeholder\"},\"buble\":{\"transforms\":{}}}!../../../node_modules/poi/node_modules/vue-loader/lib/selector?type=template&index=0!./CSpinner.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/CComponents/CSpinner.vue
// module id = 2225
// module chunks = 1611